let categoryTitle = document.querySelectorAll(".block_shop-category-list .block_tab-collection-tabtitle");

categoryTitle.forEach((event) => {
   event.addEventListener('click', (tab) => {
    let target = tab.target;
    let catrgoryHtml = target.querySelector(".block_tab-category-image-main-left").innerHTML;
    let info = target.closest(".block_shop-category-top").querySelector(".block_tab-category-image-main-left");
    info.innerHTML = catrgoryHtml;
    target.closest(".block_shop-category-top").querySelector(".block_shop-category-tab-info").classList.toggle("active");
   })
})

let catMobtitle = document.querySelectorAll(".block_shop-category-top-mobile-title"); 

catMobtitle.forEach((event) => {
   event.addEventListener('click', (tab) => {
    let target = tab.target;   
    target.closest(".block_shop-category-top").querySelector(".block_shop-category-tab-info").classList.toggle("active");
   })
})